import { onboardingHubWizardEntryPoint } from '@jira/admin-pages__onboarding-hub-wizard/src/onboardingHubWizardEntryPoint.tsx';
import { onboardingHubWizardWithDelegatedAdminEntryPoint } from '@jira/admin-pages__onboarding-hub-wizard/src/onboardingHubWizardWithDelegatedAdminEntryPoint.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { productsOnboardingHubCreateRoute } from '@atlassian/jira-router-routes-admin-pages-onboarding-hub-routes/src/productsOnboardingHubCreateRoute.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { nav4SidebarGlobalProductsSettingsEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-products/entrypoint.tsx';

const productsOnboardingHubCreateEntryPoint = createPageEntryPoint({
	main: onboardingHubWizardEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});

const productsOnboardingHubCreateWithDelegatedAdminEntryPoint = createPageEntryPoint({
	main: onboardingHubWizardWithDelegatedAdminEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
	leftSidebar: {
		sidebar: nav4SidebarGlobalProductsSettingsEntryPoint,
	},
});

export const productsOnboardingHubCreateRouteEntry = createEntry(
	productsOnboardingHubCreateRoute,
	() => ({
		group: 'global-settings',

		ufoName: 'global-admin.products.onboarding-hub-create',

		meta: {
			reporting: {
				id: 'products-onboarding-hub-create',
				teamName: 'a4t-pandora',
				packageName: 'jira-router-routes-admin-pages-onboarding-hub-entries',
			},
		},

		entryPoint() {
			if (fg('jira-onboarding-hub-gate')) {
				return fg('jira-delegated-custom-onboarding')
					? productsOnboardingHubCreateWithDelegatedAdminEntryPoint
					: productsOnboardingHubCreateEntryPoint;
			}
			return undefined;
		},

		layout: globalSettingsLayout,

		navigation: {
			menuId: MENU_ID.SETTINGS,
			sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsProducts,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-onboarding-hub-entries/src/productsOnboardingHubCreateRouteEntry.tsx',
				whichExportToUse: 'productsOnboardingHubCreateRouteEntry',
			},

			enabled: true,
		},
	}),
);
